export default __webpack_public_path__ + "static/media/Arrow.9dd7b1cd.svg";